import { NimbusPermissionSet } from '@nimbus-global/features/permissions/models/enums/nimbus-permission-set.enum';
import { NimbusPermission } from '@nimbus-global/features/permissions/models/enums/nimbus-permission.enum';
import { PermissionsModel } from '@nimbus-global/features/permissions/models/permissions.model';

export const licensingAdminPermissionSets = [NimbusPermissionSet.TenantAdmin, NimbusPermissionSet.PartnerAdminForTenant];

export const extractLicensingAdminMetadata = (
  permissionsModel: PermissionsModel,
  permission: NimbusPermission,
  currentTenantId: string = '',
): {
  isAdminForOneTenantOnly: boolean;
  tenantIds: string[];
  primaryTenantId: string;
} => {
  const tenantIds = permissionsModel
    ? permissionsModel.tenantIds.filter((id) => permissionsModel.getPermissionsEntity(id).includes(permission))
    : [];

  const isNotAdminWithOneTenant = tenantIds.length === 1 && !permissionsModel.hasPermissionSet(NimbusPermissionSet.NimbusAdmin);

  const isAdminForOneTenantOnly =
    isNotAdminWithOneTenant &&
    licensingAdminPermissionSets.some((permissionSet) => permissionsModel.hasTenantPermissionSet(tenantIds[0], permissionSet));

  const primaryTenantId = isAdminForOneTenantOnly
    ? tenantIds[0]
    : (tenantIds.find((id) => id !== currentTenantId) ?? tenantIds[0] ?? currentTenantId);

  return { isAdminForOneTenantOnly, tenantIds, primaryTenantId };
};
